import routes from '../../config/routes.json';

export enum SidebarConfigAppearsTypes {
    xs = 'xs',
    sm = 'sm',
}

export interface ISidebarConfigChild {
    key: string;
    id: string;
    link: string;
}

export interface ISidebarConfigItem extends ISidebarConfigChild {
    hidden?: boolean;
    newTab?: boolean;
    newTool?: boolean;
    appears?: SidebarConfigAppearsTypes;
    values?: ISidebarConfigChild[];
}

export default [
    {
        key: 'My Creatives',
        id: 'SidebarMyCreativesLink',
        link: routes.creatives,
    },
    {
        key: 'Affiliate Link New',
        id: 'SidebarAffiliateNewLink',
        link: routes.tools.affiliateLinks,
    },
    {
        key: 'Marking',
        id: 'SidebarMarkingLink',
        link: routes.tools.marking,
    },
] as ISidebarConfigItem[];
